import React from 'react'

import MembershipForm from '../files/rcac-friendship-form.pdf'

import Layout from '../components/layout'

const FriendsPage = () => (
  <Layout>
    <article className="cf ph3 ph5-ns pt5">
      <div className="fn fl-ns w-40-ns pr4-ns">
        <h1 className="f2 lh-title fw9 mb3 mt0 pt3 bt bw2">
          Becoming a Friend of the Arts
        </h1>
        <h2 className="f4 mid-gray lh-title">
        <a href={MembershipForm} target="_blank">Download the form</a><br/>and send it to <a href="mailto:info@rivertonarts.org.nz" target="_blank">info@rivertonarts.org.nz</a>
        </h2>
      </div>
      <div className="fn fl-ns w-60-ns">
        <p className="lh-copy measure mt0-ns">
          The Riverton Community Arts Centre invites you to become a Friend Of The Arts, or to renew your Friendship.
        </p>
        <p className="measure">
          The benefits of Friendship include:
        </p>
        <p className="measure">
          <ul>
            <li>Invitation to exhibition openings</li>
            <li>5% discount of commission for artist’s exhibiting</li>
            <li>Regular newsletters</li>
            <li>Early bird information of new exhibitions and opportunities to purchase art</li>
            <li>Supporting a charitable trust that supports emerging and established artists</li>
            <li>Being part of a thriving creative community </li>
          </ul>
        </p>
        <p className="measure">
          Friendship is $35.00 per year. You will receive an annual invoice. Friendship runs from 1 June 2018 till 31 May 2019 and will be renewed annually on that date. You can pay your Friendship by internet banking, cash or cheque.
        </p>
      </div>
    </article>
  </Layout>
)

export default FriendsPage
